import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import toast from "react-hot-toast";
import { FaGithub, FaGoogle } from "react-icons/fa";
import { Link, useNavigate, useLocation, Navigate } from "react-router-dom";
import { AuthContext } from "../context/UserContext";
import "./Register.css";

const Register = () => {
  const { createUser, github, google, updateUserProfile, verifyEmail, user } =
    useContext(AuthContext);
  const [error, setError] = useState("");
  const [accept, setAccept] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location.state);
  const from = location.state?.from?.pathname || "/";
  console.log(from);
  // console.log('create user',createUser);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value;
    const photoURL = form.photoURL.value;
    const email = form.email.value;
    const password = form.password.value;
    console.log(email, password, name, photoURL);

    createUser(email, password)
      .then((result) => {
        const user = result.user;
        console.log(user);
        form.reset();
        setError("");
        handleUpdateUserProfile(name, photoURL);
        handleEmailVerify();
        toast.success('Please Verify Your Email');
        // navigate(from, { replace: true });
      })
      .catch((error) => {
        console.error(error);
        setError(error.message);
      });
  };

  const handleEmailVerify = () => {
    verifyEmail()
    .then(()=>{})
    .catch((error) => console.error(error))
  }

  const handleUpdateUserProfile = (name, photoURL) => {
    const profile = {
      displayName: name,
      photoURL: photoURL,
    };
    updateUserProfile(profile)
      .then(() => {})
      .catch((error) => console.error(error));
  };

  const handleAccept = (e) => {
    setAccept(e.target.checked);
  };

  const googleIn = () => {
    google()
      .then((result) => {
        const user = result.user;
        console.log(user);
        // navigate(from, { replace: true });
      })
      .catch((error) => console.error(error));
  };

  const githubIn = () => {
    github()
      .then((result) => {
        const user = result.user;
        console.log(user);
        
      })
      .catch((error) => console.error(error));
  };


  // useEffect(()=>{
  //   if(user && user?.uid){
  //     navigate(from, { replace: true });
  //   }
  // },[user,from,navigate])

  return (
    <div className="register">
      {
        user?.uid && <Navigate to={from} replace></Navigate>
      }
      <div className="mt-5">
        <h1 className="container text-primary text-center  fw-bold">
          Please Register
        </h1>
        <Form
          onSubmit={handleSubmit}
          className="container bg-white-50 w-50 mt-5 "
        >
          <Form.Group className="text-start" controlId="formBasicName">
            <Form.Label>
              <h6 className="pt-3">Full Name</h6>
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="Enter Your Full Name"
            />
          </Form.Group>
          <Form.Group className="text-start" controlId="formBasicName">
            <Form.Label>
              <h6 className="pt-3">Photo URL</h6>
            </Form.Label>
            <Form.Control
              type="text"
              name="photoURL"
              placeholder="Enter Your Photo URL"
            />
          </Form.Group>
          <Form.Group className="text-start" controlId="formBasicEmail">
            <Form.Label>
              <h6 className="pt-3">Email address</h6>
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Enter Your Email"
            />
            <Form.Text className="text-muted">
              {/* We'll never share your email with anyone else. */}
            </Form.Text>
          </Form.Group>

          <Form.Group className="text-start" controlId="formBasicPassword">
            <Form.Label>
              <h6 className="pt-3">Password</h6>
            </Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Enter Your Password"
            />
          </Form.Group>
          <Form.Group className="text-start p-3" controlId="formBasicCheckbox">
            <Link to="/logIn" className="pt-4 text-success">
              Already have an account
            </Link>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              className="text-secondary "
              label="Accept Condition"
              onClick={handleAccept}
            />
          </Form.Group>
          <Button
            className="mt-2 text-center mb-3 fs-5 ps-4 pe-4 fw-semibold"
            variant="primary"
            type="submit"
            disabled={!accept}
          >
            Register
          </Button>
          <p className="text-danger">{error}</p>
        </Form>
        <div className="text-center">
          <div className="">
            <Button
              className="fs-5 text-success shadow-lg ps-5 pe-5"
              onClick={googleIn}
              variant="light"
              size="lg"
            >
              <FaGoogle className="text-center"></FaGoogle>
              <small className="ps-2">Sign in with Google</small>
            </Button>
          </div>
          <div className="mt-3">
            <Button
              className="fs-5 ps-5 pe-5 shadow-lg"
              variant="light"
              onClick={githubIn}
            >
              <FaGithub></FaGithub>
              <small className="ps-2">Sign in with Github</small>
            </Button>
          </div>
        </div>
      </div>
      <div className="in-img mt-5 pe-5">
        <img
          src="https://img.freepik.com/free-vector/cartoon-character-filling-form-survey-checklist-man-writing-test-signing-business-medical-document-flat-illustration_74855-20483.jpg?size=626&ext=jpg"
          alt=""
          className="mt-5 rounded-4 me-0 shadow-lg"
        ></img>
      </div>
    </div>
  );
};

export default Register;
